export default __webpack_public_path__ + "static/media/pricing-plan.94ef7eb5.mp4";